import { LazyPage, PipelineSourceAddSyncPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';
import { sourceRouteParams } from '@/services/router/pipeline-route-params';

function PipelineSourceAddSyncRoute() {
  return (
    <LazyPage>
      <PipelineSourceAddSyncPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/sources/$sourceId_/syncs/add')({
  params: sourceRouteParams,
  component: PipelineSourceAddSyncRoute,
});
